export const BLOCK_MODULE_NAMESPACE = 'block';
export const BLOCK_LOADING = 'BLOCK_LOADING';
export const BLOCK_DETAIL_LOADING = 'BLOCK_DETAIL_LOADING';
export const BLOCK_GET_BLOCKS_MASTER = 'BLOCK_GET_BLOCKS_MASTER';
export const BLOCK_GET_BLOCKS = 'BLOCK_GET_BLOCKS';
export const BLOCK_GET_BLOCKS_AUTOCOMPLETE = 'BLOCK_GET_BLOCKS_AUTOCOMPLETE';
export const BLOCK_GET_BLOCKS_BYQUERY= 'BLOCK_GET_BLOCKS_BYQUERY';
export const BLOCK_GET_BLOCK = 'BLOCK_GET_BLOCK';
export const BLOCK_SET_BLOCK = 'BLOCK_SET_BLOCK';
export const BLOCK_EDIT_BLOCK = 'BLOCK_EDIT_BLOCK'
export const BLOCK_INCREMENT_TOTAL_APARTMENT = 'BLOCK_INCREMENT_TOTAL_APARTMENT'
export const BLOCK_DECREMENT_TOTAL_APARTMENT= 'BLOCK_DECREMENT_TOTAL_APARTMENT'
export const BLOCK_INIT = 'BLOCK_INIT';
export const BLOCK_RESET = 'BLOCK_RESET';
export const BLOCK_RECORD = 'BLOCK_RECORD';
export const BLOCK_SET_BLOCK_BY_FIELD = 'BLOCK_SET_BLOCK_BY_FIELD';
export const BLOCK_RESET_BLOCKS = 'BLOCK_RESET_BLOCKS';
export const BLOCK_GET_BLOCKS_WITHOUT_LOADING = 'BLOCK_GET_BLOCKS_WITHOUT_LOADING';
export const BLOCK_SET_BLOCKS = 'BLOCK_SET_BLOCKS';
export const BLOCK_EXTEND_BLOCKS = 'BLOCK_EXTEND_BLOCKS'
export const BLOCK_SPLICE_BLOCKS = 'BLOCK_SPLICE_BLOCKS'
export const BLOCK_UPDATE_BLOCKS = 'BLOCK_UPDATE_BLOCKS'
export const BLOCK_SET_PAREMETER = 'BLOCK_SET_PAREMETER';
export const BLOCK_SET_CURRENT_BLOCK_BY_ID = 'BLOCK_SET_CURRENT_BLOCK_BY_ID';
export const BLOCK_APARTMENT_SIDEBAR_GET_TICKETS = 'BLOCK_APARTMENT_SIDEBAR_GET_TICKETS';
export const BLOCK_APARTMENT_SIDEBAR_SET_TICKETS = 'BLOCK_APARTMENT_SIDEBAR_SET_TICKETS';
export const TICKET_RESET_BLOCKS = 'TICKET_RESET_BLOCKS';
export const BLOCK_GET_DETAIL_STATISTIC = 'BLOCK_GET_DETAIL_STATISTIC';
export const BLOCK_GET_DETAIL_STATISTIC_LOADING = 'BLOCK_GET_DETAIL_STATISTIC_LOADING';
export const BLOCK_REDUCE_SIDEBAR_BLOCK = 'BLOCK_REDUCE_BLOCK_SIDEBAR';
export const GET_BLOCKS_BY_TETANT = 'GET_BLOCKS_BY_TETANT';
export const BLOCK_ENTITY_PARAM_MODIFIER = 'BLOCK_ENTITY_PARAM_MODIFIER'
export const BLOCK_ACTION = 'BLOCK_ACTION'
export const BLOCK_DELETE = 'BLOCK_DELETE'
export const BLOCK_UPDATE = 'BLOCK_UPDATE'
export const BLOCK_SET_LOADER_STATE= 'BLOCK_SET_LOADER_STATE'
export const BLOCK_GET_BLOCKS_BY_ID = 'BLOCK_GET_BLOCKS_BY_ID'
export const BLOCK_LOADERS= Object.freeze({
    LIST: 'BLOCK_LIST',
    INFOS: 'BLOCK_INFOS',
    DOCUMENTS: 'BLOCK_DOCUMENTS',
    CHARTS: 'BLOCK_CHARTS',
    TICKETS: 'BLOCK_TICKETS',
    FILTER: 'BLOCK_FILTER',
    CONTACT: 'BLOCK_CONTACT',
    MAINTENANCE: 'BLOCK_MAINTENANCE'
})



// WEBPACK FOOTER //
// ./src/store/block/block-types.store.ts